import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ErrorMessage } from './models/error-message.interfaces';
@Component({
  selector: 'idp-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ErrorMessageComponent {
  @Input() content: ErrorMessage = {} as ErrorMessage;

  redirect(link: string, type: string) {
    window.open(link, type === 'link' ? '_blank' : '_self');
  }
}
